import { useStore } from 'stores/Store';
import { useLazyQuery } from '@apollo/client';
import { QUERY_GET_REPORTS_BY_ENTITY_ID } from 'services/aws/session-query';
import { TestSetV2Type } from 'constants';
import { parseTestSessionDataToModel } from 'models/Entity';

const useReports = ({ entityId }) => {
  const setReports = useStore(state => state.setReports);
  const [getReports, { loading, error }] = useLazyQuery(
    QUERY_GET_REPORTS_BY_ENTITY_ID,
    {
      variables: { entityId, recurring: false }
    }
  );

  const parseReportData = reportsData => {
    if (reportsData?.getTestSessions) {
      const filteredReports = reportsData.getTestSessions.filter(
        report => report.type !== TestSetV2Type.PREVENTION_TEMPLATE
      );
      const reports = parseTestSessionDataToModel(
        filteredReports.filter(s => !s.recurring)
      );
      return [...reports];
    }
    return [];
  };

  const fetchReports = async () => {
    const { data: reportsData } = await getReports();
    const reports = parseReportData(reportsData);
    setReports(reports);
    return !!reports.length;
  };

  return {
    loading,
    error,
    fetchReports
  };
};

export default useReports;
